import { NgModule } from '@angular/core';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

//Third party modules
import { AgmCoreModule } from '@agm/core'; //Used for geolocation
import { CookieModule } from 'ngx-cookie'; //Used to manage browser cookies
import { NgxMaskModule } from 'ngx-mask'   //Used to add a mask to imput fields
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime'; // For the date/time picker

//Services
import { AuthGuard } from './services/auth-guard.service';

//Pipes
import { PhonePipe } from './util/Pipes/PhoneNumberPipe';
import { SafePipe } from './util/Pipes/SanitizeHtmlPipe';
import { AvantoTitleCasePipe } from './util/Pipes/AvantoTitleCasePipe';

//Directives
import { EqualValidator } from './util/Directives/EqualityValidatorDirective';
import { HoverClassDirective } from './util/Directives/HoverClassDirective';

//Payment Page Components
import { MonerisCheckoutComponent } from './components/body/moneris-checkout/moneris-checkout.component';
import { SquarePaymentsComponent } from './components/body/thirdPartyPayments/square-payments/square-payments.component';
import { SquareWalletButtonsComponent } from './components/body/thirdPartyPayments/square-wallet-buttons/square-wallet-buttons.component';


//Components
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { BodyComponent } from './components/body/body.component';
import { FooterComponent } from './components/footer/footer.component';
import { ChooseLocationPageComponent } from './components/body/choose-location-page/choose-location-page.component';
import { ChooseFoodPageComponent } from './components/body/choose-food-page/choose-food-page.component';
import { RestaurantBannerComponent } from './components/body/choose-food-page/restaurant-banner/restaurant-banner.component';
import { AllCategoriesSidebarComponent } from './components/body/choose-food-page/all-categories-sidebar/all-categories-sidebar.component';
import { AllCategoriesMobileBarComponent } from './components/body/choose-food-page/all-categories-mobilebar/all-categories-mobilebar.component';
import { RestaurantPriceRatingComponent } from './components/other-components/restaurant-price-rating/restaurant-price-rating.component';
import { RestaurantTagsComponent } from './components/other-components/restaurant-tags/restaurant-tags.component';
import { MenuComponent } from './components/body/choose-food-page/menu/menu.component';
import { ProductCustomizationModalComponent } from './components/other-components/product-customization-modal/product-customization-modal.component';
import { CustomizationContainerComponent } from './components/other-components/product-customization-modal/customization-container/customization-container.component';
import { QuantityPickerComponent } from './components/other-components/product-customization-modal/quantity-picker/quantity-picker.component';
import { CartContentComponent } from './components/cart/cart-content/cart-content.component';
import { CartModalComponent } from './components/cart/cart-modal/cart-modal.component';
import { SignUpComponent } from './components/body/customer-portal/customer-authentication/sign-up/sign-up.component';
import { CustomerDashboardComponent } from './components/body/customer-portal/customer-dashboard/customer-dashboard.component';
import { CustomerAuthenticationComponent } from './components/body/customer-portal/customer-authentication/customer-authentication.component';
import { LoginComponent } from './components/body/customer-portal/customer-authentication/login/login.component';
import { CheckoutPageComponent } from './components/body/checkout-page/checkout-page.component';
import { GeolocationComponent } from './components/other-components/geolocation/geolocation.component';
import { OrderDetailsModalComponent } from './components/other-components/order-details-modal/order-details-modal.component';
import { DisplayedProductComponent } from './components/body/choose-food-page/menu/displayed-product/displayed-product.component';
import { OrderCompletePageComponent } from './components/body/order-complete-page/order-complete-page.component';
import { PlacehoderProductComponent } from './components/body/choose-food-page/menu/placeholder-product/placeholder-product.component';
import { ConfirmVerificationCodeComponent } from './components/body/customer-portal/customer-authentication/confirm-verification-code/confirm-verification-code.component';
import { LoadingOverlayComponent } from './components/other-components/loading-overlay/loading-overlay.component';
import { ForgotPasswordComponent } from './components/body/customer-portal/customer-authentication/forgot-password/forgot-password.component';
import { MobileNavbarComponent } from './components/mobile-navbar/mobile-navbar.component';
import { MaintinenceComponent } from './components/maintinence/maintinence.component';
import { HttpClientModule } from '@angular/common/http';
import { PizzaSizePickerComponent } from './components/other-components/product-customization-modal/pizza-size-picker/pizza-size-picker.component';

const appRoutes: Routes = [
  //THE TO '/' WILL USUALLY REDIRECT TO OUR STATIC WEBPAGE. READ THE APP.COMPONENT.TS!!!
  {path: '', component: ChooseLocationPageComponent},
  {path: 'choose-restaurant', component: ChooseLocationPageComponent},
  {path: 'restaurant/:region/:clientId', component: ChooseFoodPageComponent},
  {path: 'menu/:region/:clientId', component: ChooseFoodPageComponent},
  {path: 'checkout', component: CheckoutPageComponent},
  {path: 'checkout/:orderStatus', component: OrderCompletePageComponent},
  {path: 'moneris/checkout/:status', component: MonerisCheckoutComponent},
  {path: 'square/checkout/:params', component: SquarePaymentsComponent},
  //Customer portal
  {path: 'customer/authentication/:page', component: CustomerAuthenticationComponent},
    //Requires the user to be logged in
    {path: 'customer/dashboard', component: CustomerDashboardComponent, canActivate: [AuthGuard] },
];

@NgModule({
  declarations: [
    EqualValidator,
    HoverClassDirective,
    AppComponent,
    AllCategoriesSidebarComponent,
    AllCategoriesMobileBarComponent,
    HeaderComponent,
    MenuComponent,
    BodyComponent,
    FooterComponent,
    ChooseLocationPageComponent,
    RestaurantBannerComponent,
    ProductCustomizationModalComponent,
    CustomizationContainerComponent,
    ChooseFoodPageComponent,
    RestaurantPriceRatingComponent,
    RestaurantTagsComponent,   
    QuantityPickerComponent, 
    CartContentComponent, 
    CartModalComponent, 
    SignUpComponent, 
    CustomerDashboardComponent, 
    CustomerAuthenticationComponent,
    LoginComponent,
    CheckoutPageComponent,
    GeolocationComponent,
    OrderDetailsModalComponent,
    DisplayedProductComponent,
    OrderCompletePageComponent,
    PlacehoderProductComponent,
    PhonePipe,
    AvantoTitleCasePipe,
    SafePipe,
    ConfirmVerificationCodeComponent,
    LoadingOverlayComponent,
    ForgotPasswordComponent,
    MobileNavbarComponent,
    MaintinenceComponent,
    MonerisCheckoutComponent,
    PizzaSizePickerComponent,
    SquarePaymentsComponent,
    SquareWalletButtonsComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    HttpModule,
    OwlDateTimeModule, 
    OwlNativeDateTimeModule,
    CookieModule.forRoot(),
    NgxMaskModule.forRoot(),
    RouterModule.forRoot(appRoutes),
    AgmCoreModule.forRoot({
      apiKey:"AIzaSyDovGvF6gpnzl26S5mDyf-0mXhLTJM-hyM",
      libraries: ['places']
    }),
  ],
  providers: [ ],
  bootstrap: [AppComponent]
})

export class AppModule {}
